import { store } from "@store";
import { getItem } from "@lib/storage";

const getTokenZ = async () => {
  let token = null;
  token = store?.getState()?.auth?.userToken;
  if (!token) {
    token = await getItem("user_token");
  }
  console.log(token);
  return token;
};

export default getTokenZ;
